import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import apiService from '../../service/apiService';
import { useEffect } from "react";
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    Box, Autocomplete
} from '@mui/material';
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
const AddPlan = () => {
    const [years, setYears] = useState([]);
    const [farmers, setFarmers] = useState([]);
    const [cropTypes, setCropTypes] = useState([]);
    const [seeds, setSeeds] = useState([]);
    const [seedVarieties, setSeedVarieties] = useState([]);
    const navigate = useNavigate();
    const [seedClasses, setSeedClasses] = useState([]);
    const [seasons, setSeasons] = useState([]);
    const [formData, setFormData] = useState({
        seasonId: '',
        yearId: '',
        farmerId: '',
        cropPlans: [
            {
                cropTypeId: '',
                seedId: '',
                seedVarietyId: '',
                seedClassId: '',
                area: '',
                leaseArea: '',
                quantity: '',
            },
        ],
    });

    const [dists, setAllDists] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [pgs, setPgs] = useState([]);
    const loginData = JSON.parse(localStorage.getItem("loginData"));
    const [dist, setDist] = useState(loginData?.districtId ? loginData.districtId : 0);
    const [blk, setBlk] = useState(loginData?.blockId ? loginData.blockId : 0);
    const isDistCoordinator = loginData?.districtCoordinatorsId !== null;
    const isBlockCoordinator = loginData?.blockCoordinatorsId !== null;
    const [pgId, setPgId] = useState(0);
    const [farmerIdNo, setFarmerIdNo] = useState(0);
    const [farmerdetails, setFarmerDetails] = useState([]);
    const [farmerinitial, setFarmerInitial] = useState(false);
    
    const fetchAllDist = async () => {
        try {
          const response = await apiService.get('/districts/get-all');
          setAllDists(response.data);
        } catch (error) {
          console.error('Error fetching districts:', error);
        }
      };
      const fetchBlocks = async () => {
        try {
          const response = await apiService.get(`/master/get-block-by-district/${dist}`);
          setBlocks(response.data.body.blocks);
        } catch (error) {
          console.error("Error fetching blocks:", error);
        }
      };
      const fetchPG = async () => {
        try {
          const response = await apiService.get(`/master/get-pg-by-block/${blk}`);
          setPgs(response.data.body);  
        } catch (error) {
          console.error("Error fetching blocks:", error);
        }
      };

      const fetchFarmerBYPgId = async () => {
        try {
            const response = await apiService.post(`/farmers/detail`, {
                ProducerGroupId: [pgId] 
            });
            setFarmers(response.data);  
        } catch (error) {
            console.error("Error fetching farmers:", error);
        }
      };

      const fetchFarmerDetailsById = async () => {
        try {
            const response = await apiService.get(`/farmers/get-farmer-details/${farmerIdNo}`);
            setFarmerDetails(response.data.body); 
            setFarmerInitial(true); 
        } catch (error) {
            console.error("Error fetching farmers:", error);
        }
      };

       useEffect(() => {
              fetchAllDist();
          }, []);

          useEffect(() => {
                if (dist > 0) {
                fetchBlocks();
                }
            }, [dist]);
            
            useEffect(() => {
                if (blk > 0) {
                fetchPG();
                }
            }, [blk]);

            useEffect(() => {
                if (pgId > 0) {
                    fetchFarmerBYPgId();
                }
            }, [pgId]);

            useEffect(() => {
                if (farmerIdNo > 0) {
                    fetchFarmerDetailsById();
                }
            }, [farmerIdNo]);
    useEffect(() => {
        const fetchSeasons = async () => {
            try {
                const response = await apiService.get("/seasons/get-all");
                setSeasons(response.data); 
            } catch (error) {
                console.error("Error fetching seasons:", error);
            }
        };


        fetchSeasons();
    }, []);

    useEffect(() => {
        apiService
            .get('/years/get-all')
            .then((response) => {
                setYears(response.data);
            })
            .catch((error) => {
                console.error('Error fetching years:', error);
            });
    }, []);
    useEffect(() => {
        apiService.get('/croptypes/get-all-croptypes')
            .then((response) => {
                setCropTypes(response.data);
            })
            .catch((error) => {
                console.error('Error fetching crop types:', error);
            });
    }, []);

    useEffect(() => {
        // Fetch seeds from the API
        apiService.get('/seeds/get-all')
            .then((response) => {
                // Assuming response.data is an array of seeds
                setSeeds(response.data);
            })
            .catch((error) => {
                console.error('Error fetching seeds:', error);
            });
    }, []);


    useEffect(() => {
        // Fetch seed varieties from the API
        apiService.get('/seed-varieties/get-all')
            .then((response) => {
                // Assuming response.data is an array of seed varieties
                setSeedVarieties(response.data);
            })
            .catch((error) => {
                console.error('Error fetching seed varieties:', error);
            });
    }, []);

    useEffect(() => {
        // Fetch seed classes from the API
        apiService.get('/seed-classes/get-all')
            .then((response) => {
                // Assuming response.data is an array of seed classes
                setSeedClasses(response.data);
            })
            .catch((error) => {
                console.error('Error fetching seed classes:', error);
            });
    }, []);

    const [message, setMessage] = useState('');

    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
    
        useEffect(() => {
          const requiredFields = [
            "farmerId",
            "seasonId",
            "seasonId",
          ];
        
          const isAnyFieldEmpty = requiredFields.some(
            (field) => !formData[field] || formData[field] === 0 || formData[field] === "" || blk === 0 || dist === 0 || pgId === 0
          );
        
          setIsSaveDisabled(isAnyFieldEmpty);
        }, [formData, blk, dist, pgId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    // const handleCropPlanChange = (index, e) => {
    //     const { name, value } = e.target;
    //     const updatedCropPlans = formData.cropPlans.map((cropPlan, i) =>
    //         i === index ? { ...cropPlan, [name]: value } : cropPlan
    //     );
    //     setFormData({ ...formData, cropPlans: updatedCropPlans });
    // };

    const handleCropPlanChange = (index, event) => {
        const { name, value } = event.target;
        const newValue = value === "" ? "" : parseFloat(value) || 0;
    
        if (name === "area") {
            const totalAllocatedArea = formData.cropPlans.reduce((acc, plan, i) => {
                return i !== index ? acc + (parseFloat(plan.area) || 0) : acc;
            }, 0);
    
            if (totalAllocatedArea + (newValue || 0) > farmerdetails.availableLand) {
                alert(`Total allocated area cannot exceed ${farmerdetails.availableLand}`);
                return;
            }
        }
    
        const updatedCropPlans = [...formData.cropPlans];
        updatedCropPlans[index] = { ...updatedCropPlans[index], [name]: newValue };
    
        // Find selected seed's plannedWeight
        const selectedSeed = seeds.find(seed => seed.seedId === updatedCropPlans[index].seedId);
        const plannedWeight = selectedSeed ? selectedSeed.plannedWeight : 0;
    
        // Calculate quantity based on (area + leaseArea) * plannedWeight
        const area = parseFloat(updatedCropPlans[index].area) || 0;
        const leaseArea = parseFloat(updatedCropPlans[index].leaseArea) || 0;
        const quantity = (area + leaseArea) * plannedWeight;
    
        updatedCropPlans[index].quantity = quantity; // Auto-update quantity field
    
        setFormData(prevData => ({
            ...prevData,
            cropPlans: updatedCropPlans
        }));
    };        

    const addCropPlan = () => {
        setFormData({
            ...formData,
            cropPlans: [
                ...formData.cropPlans,
                {
                    cropTypeId: '',
                    seedId: '',
                    seedVarietyId: '',
                    seedClassId: '',
                    area: '',
                    leaseArea: '',
                    quantity: '',
                },
            ],
        });
    };

    const removeCropPlan = (index) => {
        const updatedCropPlans = formData.cropPlans.filter((_, i) => i !== index);
        setFormData({ ...formData, cropPlans: updatedCropPlans });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Show confirmation dialog before submitting
        const isConfirmed = window.confirm("Are you sure you want to add this crop plan?");

        if (!isConfirmed) {
            return; // If user cancels, exit the function without submitting
        }

        const numericData = {
            seasonId: Number(formData.seasonId),
            yearId: Number(formData.yearId),
            farmerId: Number(formData.farmerId),
            cropPlans: formData.cropPlans.some(plan => plan.cropTypeId && plan.seedId && plan.seedVarietyId && plan.seedClassId && plan.area) 
            ? formData.cropPlans.map((plan) => ({
                cropTypeId: Number(plan.cropTypeId),
                seedId: Number(plan.seedId),
                seedVarietyId: Number(plan.seedVarietyId),
                seedClassId: Number(plan.seedClassId),
                area: Number(plan.area),
                leaseArea: Number(plan.leaseArea),
                quantity: Number(plan.quantity),
            }))
            : [],
        };

        try {
            const response = await apiService.post('/crop-plan-master/create', numericData);
            if (response.data.status) {
                alert("Crop Plan Created Successfully");
                navigate(-1);
            } else {
                alert(response.data.message); 
            }
        } catch (error) {
            setMessage(`Error: ${error.response ? error.response.data.message : 'Something went wrong'}`);
        }
    };
    const handleCancel = () => {
        navigate(-1); 
    };

    return (
        <div className='container-fluid' style={{ maxHeight: "100vh", overflowX: "auto" }}>
            <div className='mx-3 mt-2 d-flex justify-content-between'>
                <h4 className='text-bold'>Add Crop Plan</h4>
                <p><span className='text-danger text-bold' style={{ fontSize: "18px" }}>*</span> mark fields are mandetory</p>
            </div>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="dist-label">
                                District<span style={{ color: "red" }}> *</span>
                            </InputLabel>
                            <Select
                                labelId="dist-label"
                                label={
                                    <>
                                        District <span style={{ color: "red" }}>*</span>
                                    </>
                                }
                                name="districtId"
                                value={formData.districtId || dist}
                                onChange={(e) => {
                                    setDist(e.target.value);
                                    setFormData((prev) => ({ ...prev, districtId: e.target.value }));
                                }}
                                disabled={isDistCoordinator}
                                variant="outlined"
                            >
                                <MenuItem value={0} disabled>Select District</MenuItem>
                                {dists.map((d) => (
                                    <MenuItem key={d.districtId} value={d.districtId}>
                                        {d.districtName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth margin="dense">
                            <InputLabel id="block-label">
                                Block<span style={{ color: "red" }}> *</span>
                            </InputLabel>
                            <Select
                                labelId="block-label"
                                label={
                                    <>
                                        Block <span style={{ color: "red" }}>*</span>
                                    </>
                                }
                                name="blockId"
                                value={blk}
                                onChange={(e) => setBlk(e.target.value)}
                                disabled={isBlockCoordinator}
                                variant="outlined"
                            >
                                <MenuItem value={0} disabled>Select Block</MenuItem>
                                {blocks.map((b) => (
                                    <MenuItem key={b.blockId} value={b.blockId}>
                                        {b.blockName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth margin="dense">
                            <InputLabel id="pg-label">
                                PG<span style={{ color: "red" }}> *</span>
                            </InputLabel>
                            <Select
                                labelId="pg-label"
                                label={
                                    <>
                                        PG <span style={{ color: "red" }}>*</span>
                                    </>
                                }
                                value={pgId}
                                name="pgId"
                                onChange={(e) => setPgId(e.target.value)}
                                variant="outlined"
                            >
                                <MenuItem value={0} disabled>Select PG</MenuItem>
                                {pgs.map((d) => (
                                    <MenuItem key={d.producerGroupId} value={d.producerGroupId}>
                                        {d.pgName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" margin="dense">
                            <InputLabel htmlFor="seasonId">Season <span style={{ color: "red" }}>*</span></InputLabel>
                            <Select
                                id="seasonId"
                                name="seasonId"
                                value={formData.seasonId}
                                onChange={handleInputChange}
                                required
                                label={
                                    <>
                                        Season <span style={{ color: "red" }}>*</span>
                                    </>
                                }
                            >
                                <MenuItem value="">Select Season</MenuItem>
                                {seasons.map((season) => (
                                    <MenuItem key={season.seasonId} value={season.seasonId}>
                                        {season.seasonName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth variant="outlined" margin="dense">
                            <InputLabel htmlFor="yearId">Year <span style={{ color: "red" }}>*</span></InputLabel>
                            <Select
                                id="yearId"
                                name="yearId"
                                value={formData.yearId}
                                onChange={handleInputChange}
                                required
                                label={
                                    <>
                                        Year <span style={{ color: "red" }}>*</span>
                                    </>
                                }
                            >
                                <MenuItem value="">Select a Year</MenuItem>
                                {years.map((year) => (
                                    <MenuItem key={year.yearId} value={year.yearId}>
                                        {year.yearValue}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Autocomplete
                            id="farmerId"
                            options={farmers}
                            getOptionLabel={(option) => option.FarmerName || ""}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={
                                        <>
                                            Farmer Name <span style={{ color: "red" }}>*</span>
                                        </>
                                    }
                                    variant="outlined"
                                    margin="dense"
                                />
                            )}
                            onChange={(event, newValue) => {
                                handleInputChange({
                                    target: { name: "farmerId", value: newValue ? newValue.FarmerId : "" },
                                });
                                setFarmerIdNo(newValue ? newValue.FarmerId : 0);
                            }}
                            value={farmers.find((farmer) => farmer.FarmerId === formData.farmerId) || null}
                            isOptionEqualToValue={(option, value) => option.FarmerId === value.FarmerId}
                            margin="dense"
                        />
                    </Grid>
                </Grid>
                {farmerdetails.availableLand > 0 ? (
                    <>
                    
                <div className='mx-3 mt-3 mb-2 d-flex '>
                    <h5 className='text-bold mr-3 align-middle'>Add Plan Details</h5>
                    {(() => {
            const totalEnteredArea = formData.cropPlans.reduce(
                (acc, plan) => acc + Number(plan.area || 0), 0
            );
            return totalEnteredArea < farmerdetails.availableLand ? (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={addCropPlan}
                    >
                        Add Plan Details
                    </Button>
                    ) : null; // Hide button if total area reaches available land
                })()}
                </div>
            
                <Grid container spacing={2}>
                    {formData.cropPlans.map((cropPlan, index) => (
                        <Grid item xs={6} key={index}>
                            <Box p={2} border="1px solid #ddd" borderRadius={2}>

                                <div className='mb-1 d-flex justify-content-between'>
                                    <h5 className='text-bold'>Enter Details</h5>
                                    <IconButton
                                        variant="contained"
                                        style={{ color: "Red" }}
                                        onClick={() => removeCropPlan(index)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </div>

                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel>Crop Type</InputLabel>
                                            <Select
                                                name="cropTypeId"
                                                value={cropPlan.cropTypeId}
                                                onChange={(e) => handleCropPlanChange(index, e)}
                                                // required
                                                label="Crop Type"
                                            >
                                                <MenuItem value="">Select Crop Type</MenuItem>
                                                {cropTypes.map((cropType) => (
                                                    <MenuItem key={cropType.cropTypeId} value={cropType.cropTypeId}>
                                                        {cropType.cropType}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel>Seed</InputLabel>
                                            <Select
                                                name="seedId"
                                                value={cropPlan.seedId}
                                                onChange={(e) => handleCropPlanChange(index, e)}
                                                // required
                                                label="Seed"
                                            >
                                                <MenuItem value="">Select Seed</MenuItem>
                                                {seeds.map((seed) => (
                                                    <MenuItem key={seed.seedId} value={seed.seedId}>
                                                        {seed.seedName.trim()}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel>Seed Variety</InputLabel>
                                            <Select
                                                name="seedVarietyId"
                                                value={cropPlan.seedVarietyId}
                                                onChange={(e) => handleCropPlanChange(index, e)}
                                                // required
                                                label="Seed Variety"
                                            >
                                                <MenuItem value="">Select Seed Variety</MenuItem>
                                                {seedVarieties.map((variety) => (
                                                    <MenuItem key={variety.seedVarietyId} value={variety.seedVarietyId}>
                                                        {variety.varietyName.trim()}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel>Seed Class</InputLabel>
                                            <Select
                                                name="seedClassId"
                                                value={cropPlan.seedClassId}
                                                onChange={(e) => handleCropPlanChange(index, e)}
                                                // required
                                                label="Seed Class"
                                            >
                                                <MenuItem value="">Select Seed Class</MenuItem>
                                                {seedClasses.map((seedClass) => (
                                                    <MenuItem key={seedClass.seedClassId} value={seedClass.seedClassId}>
                                                        {seedClass.className}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            name="area"
                                            label="Area"
                                            type="number"
                                            value={cropPlan.area}
                                            onChange={(e) => handleCropPlanChange(index, e)}
                                            // required
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            name="leaseArea"
                                            label="Lease Area"
                                            type="number"
                                            value={cropPlan.leaseArea}
                                            onChange={(e) => handleCropPlanChange(index, e)}
                                            // required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            name="leaseArea"
                                            label="Lease Area"
                                            type="number"
                                            value={cropPlan.leaseArea}
                                            onChange={(e) => handleCropPlanChange(index, e)}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            name="quantity"
                                            label="Quantity"
                                            type="number"
                                            value={cropPlan.quantity}
                                            disabled
                                            // onChange={(e) => handleCropPlanChange(index, e)}
                                            // required
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
                </>
                ) : (
                    <p className="text-danger mt-3 ml-2">
                        {farmerinitial ? "This farmer has no available land." : "Choose a farmer to add plan details."}
                    </p>
                )}

                <Grid item xs={12} className="mt-3 d-flex justify-content-end">
                    <Button variant="contained" color="primary" type="submit" className="me-2" disabled={isSaveDisabled}>
                        Submit
                    </Button>
                    <Button variant="outlined" color="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                </Grid>

            </form>
        </div>
    );
};

export default AddPlan;
